'use client';
import { polyfillResolve } from './manifest.utils.js';

let t = [
    {
        loadCondition: ()=>'undefined' != typeof window && void 0 === window.HTMLDialogElement,
        scriptFileName: 'modal-dialog.js'
    },
    {
        loadCondition: ()=>'undefined' != typeof window && window.CSS && CSS.supports && !1 === CSS.supports('selector(:focus-visible)'),
        scriptFileName: 'focus-visible.js'
    }
];
function getSwanScriptPolyfillUrl(t, l) {
    return polyfillResolve(t, l);
}
function generatePolyfillElements(e) {
    let l = document.createDocumentFragment();
    return t.forEach((t)=>{
        let { loadCondition: o, scriptFileName: i } = t;
        if (o() && i) {
            let t = getSwanScriptPolyfillUrl(i, e);
            if (!document.querySelector(`script[src="${t}"]`)) {
                let e = document.createElement('script');
                e.src = t, e.type = 'text/javascript', e.defer = !0, l.appendChild(e);
            }
        }
    }), {
        scriptFragment: l
    };
}
const loadSwanPolyfill = (e)=>{
    let { scriptFragment: t } = generatePolyfillElements(e);
    document.head.appendChild(t);
};

export { getSwanScriptPolyfillUrl, loadSwanPolyfill };
